<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand" to="/">
                <img src="img/brand/3Zlogo_white.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="/">
                        <img width="" height="" src="img/brand/3Zlogo_big.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <router-link class="nav-link nav-link-icon" to="/">
                        <span class="nav-link-inner--text">HOME</span>
                    </router-link>
                </li>
                <base-dropdown tag="li" title="PRODUCTS & SOLUTIONS">
                    <router-link class="dropdown-item" to="/Controller">Controller</router-link>
                    <router-link class="dropdown-item" to="/FlexYard">FlexYard</router-link>
                    <router-link class="dropdown-item" to="/FlexTrim">FlexTrim</router-link>
                    <router-link class="dropdown-item" to="/FlexDraw">FlexDraw</router-link>
                    <router-link class="dropdown-item" to="/Update">Updating Existing Hump System</router-link>
                </base-dropdown>
                <base-dropdown tag="li" title="PROJECTS">
                    <router-link class="dropdown-item" to="/projectFlexyard">FlexYard - CP St. Paul Hump Yard</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim1">FlexTrim - BNSF Argentine yard</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim2">FlexTrim - Union Pacific Settegast Trim System</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim3">FlexTrim - BNSF Argentine Blue Flag System</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim4">FlexTrim - Union Pacific Englewood Trim System</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim5">FlexTrim - Union Pacific Hinkle yard</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim6">FlexTrim - Union Pacific Sosan yard</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim7">FlexTrim - BNSF Tacoma Blue Flag System</router-link>
                    <router-link class="dropdown-item" to="/ProjectFlextrim8">FlexTrim - BNSF Hobson yard</router-link>
                </base-dropdown>
                <base-dropdown tag="li" title="INDUSTRIES & APPLICATIONS">
                    <router-link class="dropdown-item" to="/WebBase">Web Based Logging & Reporting</router-link>
                    <router-link class="dropdown-item" to="/Report">Online Reports</router-link>
                    <router-link class="dropdown-item" to="/Computer">Computer Aided Design</router-link>
                </base-dropdown>
                <li class="nav-item">
                    <router-link class="nav-link nav-link-icon" to="/About">
                        <span class="nav-link-inner--text">ABOUT</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link nav-link-icon" to="/Contact">CONTACT</router-link>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link nav-link-icon" to="/Download">DOWNLOAD</router-link>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>

</style>
